import { render, staticRenderFns } from "./anfragen_table.vue?vue&type=template&id=37b9dca5&scoped=true"
import script from "./anfragen_table.vue?vue&type=script&lang=js"
export * from "./anfragen_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9dca5",
  null
  
)

export default component.exports